import selectCustomerReducer from './select-customer';
import selectTypeReducer from './select-type';
import selectItemsReducer from './select-items';
import draftsReducer from './drafts';
import scheduledReducer from './scheduled';
import bonificationReducer from './bonification';
import approvalReducer from './approval';
import historyReducer from './history';
import financialDiscounts from './financial-discounts';
import sellerReducer from './select-seller';
export * from './select-customer';
export { 
    clearTempItems, 
    fetchOrdersToBonitifaction, 
    resetBonification,
    bonificationSelector,
    bonificationTableSelector,
    addOrderToBonification,
    setSelectedOrders,
    addTempItems,
    saveBonificationOrder
} from './bonification';
export type { OrderBonificationTable } from './bonification';
export { 
    clearState,
    orderItemsSelector,
    fetchAvailableItems,
    fetchAvailablePaymentConditions,
    fetchConvenio,
    fetchCustos,
    fetchMoedas,
    fetchMoedasSimbolos,
    fetchOrder,
    fetchPaymentCondition,
    fetchPdiscqtWithType,
    fetchSemaphores,
    updateCampaignItems,
    updateMoeda,
    updateOrder,
    updateItem,
    updateItemApi,
    updateCanSaveReason,
    filterItems,
    verifyCanSaveReasons,
    hasANTECSelector,
    resetSelectItemsState,
    fetchPdiscqt,
    updateOrderState,
    cloneApiOrder,
    saveApiOrder,
    sendOrder,
    fetchApproversForOrder,
    resetAvailableItems,
    initialItemsState,
    updateOrderPlatform
} from './select-items';
export type { 
    IOrderItemsSelectorState,
    IFilterSelectItems,
    ApproverOrder
} from './select-items';
export { 
    fetchDrafts, 
    draftsSelector,
    draftsDashboardValues,
    fetchDraftsDashboard,
    removeDrafts,
    sendedOrdersValues
} from './drafts';
export type { 
    DraftsTable,
    DraftsResponse 
} from './drafts';
export { 
    requestChangeBranch, 
    setOrderType, 
    orderTypeSelector, 
    fetchAvailableTypes,
    fetchAvailablePlatforms,
    addAvailablePlatform,
    selectType,
    fetchAllAvailablePlatforms,
    fetchAvailablePlatformsByDivision,
    selectTypePlatform,
    showModalBranch,
    closeModalBranch,
    updatePlatform,
    requestVerifyChangeBranch
} from './select-type';
export {
    resetSellerState,
    fetchSellers,
    sellerSelector,
    updateSeller
} from './select-seller';
export * from './approval';

export default {
    selectCustomer: selectCustomerReducer,
    selectSeller: sellerReducer,
    selectType: selectTypeReducer,
    selectItems: selectItemsReducer,
    drafts: draftsReducer,
    bonification: bonificationReducer,
    scheduled: scheduledReducer,
    approval: approvalReducer,
    history: historyReducer,
    financialDiscounts: financialDiscounts,
};
